<template>
	<transition name="fade-in">
	<div class="overlay" v-show="show" @click.self.prevent="close" />
	</transition>
</template>

<script>
	export default {
		name: "Overlay",
		data() {
			return {
				show : false
			}
		},
		props: [],
		methods: {
			close ( ) {
				this.show = false;
				Events.$emit( 'overlay:closed', true );
			},
			open () {
				this.show = true;
				Events.$emit( 'overlay:opened', true );
			}
		},
		created() {
			Events.$on('overlay:open', this.open );
			Events.$on('overlay:close', this.close );
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/subparts/Overlay.vue